import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Marker } from 'react-mapbox-gl'
import { withRouter } from 'react-router-dom'
import { array, number, bool, object, string } from 'prop-types'
import MdAutorenew from 'react-icons/lib/md/autorenew'
import { addressBasedSearch } from '../../../store/Actions/MapActions'
import { withinSearchRadius } from '../../../utils/withinSearchRadius'
import { minZoomForSearch } from '../../../config'
import { SignCountDiv } from '../styles/SignCounts'
import '../styles/Clusters.css'

const checkCounts = (zoom, counts, coordinates, listShow) =>
  zoom && counts !== 0 && coordinates === null && !listShow ? true : false

const SignCountContainer = ({ addHistory, children, numberColor, theme }) => (
  <SignCountDiv
    numberColor={numberColor}
    theme={theme}
    onClick={() => addHistory()}
  >
    {children}
  </SignCountDiv>
)

const SignCountData = ({ counts }) => (
  <Fragment>
    <p>
      <strong>{counts}</strong>
    </p>
    <p>SIGNS</p>

    {/* <div className="sign-counts-support" /> */}
  </Fragment>
)

const CheckLoading = ({ counts, loading }) =>
  loading ? (
    <MdAutorenew color="green" className="loading" />
  ) : (
    <SignCountData counts={counts} />
  )

const SignCounts = ({
  center,
  radius,
  counts,
  zoom,
  infobox,
  category,
  history,
  listShow,
  loading,
  withinSearchRadius,
  coordParams,
  withinZoomLevel,
  theme,
  streetViewOpen,
  addressBasedSearch,
}) =>
  checkCounts(zoom, counts, infobox.coordinates, listShow) &&
  (!withinSearchRadius &&
    !streetViewOpen &&
    withinZoomLevel && (
      <Marker coordinates={center} anchor="bottom">
        <SignCountContainer
          addHistory={() => {
            addressBasedSearch(false)
            history.push(`/${coordParams}/${category}/${radius}`)
          }}
          numberColor={zoom < 17 ? '#c0392b' : 'black'}
          theme={theme}
        >
          <CheckLoading counts={counts} loading={loading} />
        </SignCountContainer>
      </Marker>
    ))

SignCounts.propTypes = {
  center: array.isRequired,
  radius: number.isRequired,
  counts: number.isRequired,
  zoom: number.isRequired,
  infobox: object.isRequired,
  category: array.isRequired,
  listShow: bool.isRequired,
  withinSearchRadius: bool.isRequired,
  withinZoomLevel: bool.isRequired,
  theme: string.isRequired,
}

const mapStateToProps = ({ map, signsState, spi, ui }) => ({
  center: map.center,
  radius: map.radius,
  counts: signsState.signCounts,
  zoom: map.zoom,
  infobox: map.infobox,
  category: spi.category,
  listShow: ui.listShow,
  loading: signsState.loading,
  coordParams: map.coordParams,
  withinSearchRadius:
    signsState.signs.length > 0
      ? withinSearchRadius(map.cache.center, map.center)
      : false,
  withinZoomLevel: map.zoom >= minZoomForSearch,
  theme: spi.theme,
  streetViewOpen: ui.streetViewShow || ui.cycloramaShow,
})

const actions = {
  addressBasedSearch: addressBasedSearch,
}

export default withRouter(
  connect(
    mapStateToProps,
    actions
  )(SignCounts)
)



// WEBPACK FOOTER //
// ./src/components/Map/Markers/SignCounts.jsx